import { jsx as _jsx } from "react/jsx-runtime";
const VISIBLE_DAYS = 60;
const formatDateLabel = (value) => {
    const date = new Date(value);
    return date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric'
    });
};
const StatusTimeline = ({ timeline }) => {
    if (!timeline.length) {
        return (_jsx("div", { className: "timeline-wrapper", children: _jsx("div", { className: "timeline-placeholder", children: "No data" }) }));
    }
    const visibleTimeline = timeline.length > VISIBLE_DAYS
        ? timeline.slice(timeline.length - VISIBLE_DAYS)
        : timeline;
    return (_jsx("div", { className: "timeline-row", children: visibleTimeline.map((entry) => (_jsx("span", { className: `timeline-pill timeline-pill--${entry.availability}`, title: `${formatDateLabel(entry.date)} • ${entry.uptimePercent.toFixed(1)}%` }, entry.date))) }));
};
export default StatusTimeline;
